import { useCallback, useEffect, useState } from 'react';

export const CAPTCHA_HEADER = 'x-gx-cap-token';
const RECAPTCHA_REFRESH_INTERVAL = 30000;
const RECAPTCHA_EXPIRY_TIMEOUT = 60000;

const useReCaptchaToken = () => {
  const [captchaToken, setCaptchaToken] = useState('');
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);

  const onVerify = useCallback((token: string) => {
    setCaptchaToken(token);
  }, []);

  useEffect(() => {
    const id = setInterval(() => {
      setRefreshReCaptcha(r => !r);
    }, RECAPTCHA_REFRESH_INTERVAL);
    return () => {
      clearInterval(id);
    };
  }, []);

  useEffect(() => {
    const id = setTimeout(() => {
      setRefreshReCaptcha(r => !r);
    }, RECAPTCHA_EXPIRY_TIMEOUT);
    return () => {
      clearTimeout(id);
    };
  }, [refreshReCaptcha]);

  const refreshToken = useCallback(() => {
    setRefreshReCaptcha(r => !r);
  }, []);

  return { captchaToken, refreshReCaptcha, onVerify, refreshToken };
};

export default useReCaptchaToken;
